import { a34, a217 } from "./RootApiPath";

class PayLoadService {

    async sendPayload(items) {

        console.error('checking items ', items);
        const payload = this.constructPayload(items);

        console.error('checking payload ', payload);

        try {
            const response = await fetch(a217, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(payload),
            });
      
            if (!response.ok) {
              const errorDetails = await response.json(); // Parse error details
              throw new Error(
                JSON.stringify({
                  status: response.status,
                  message: errorDetails.Title || 'API call failed',
                  errors: errorDetails.Errors || {},
                  traceId: errorDetails.traceId || null,
                })
              );
            }
      
            return await response.json(); // Returns the API response
          } catch (error) {
            console.error('Error in API call:', error);
            throw error; // Propagate error back to the caller
          }
    }

    constructPayload(items) {
        // Directly return the array of items without wrapping in an object
        return items.map((item) => ({
            ...item,
            grosswt: String(item.GrossWt), // Ensure property names are correct
            GrossWt: String(item.GrossWt),
            CollectionId: item.CollectionId || 0,
            PacketId: item.PacketId || 0,
            BoxId: parseInt(item.BoxId || 0),
            WeightCategory: item.WeightCategory || 0,
            PackingWeight : item.PackingWeight  || 0,
            LotNumber:item.LotNumber || '0',
            SKUId: parseInt(item.SKUId || 0),
            TotalStoneWeight: String(item.TotalStoneWeight || "0"),
            TotalStoneAmount: String(item.TotalStoneAmount || "0"),
            TotalStonePieces: String(item.TotalStonePieces || "0"),
            TotalDiamondWeight: String(item.TotalDiamondWeight || "0"),
            TotalDiamondAmount: String(item.TotalDiamondAmount || "0"),
            NetWt:String(item.NetWt||'0'),
            Status : 'Active',
            Stones: item.Stones.map(stone => ({
                ...stone,
                StoneAmount: String(stone.StoneAmount || "0"), // Convert to string
                StoneWeight: String(stone.StoneWeight || "0"), // Convert to string
                StonePieces: String(stone.StonePieces || "0"),
                StoneRate: String(stone.StoneRate || '0')
            })),
            Diamonds: item.Diamonds.map(stone => ({
              ...stone,
              DiamondAmount: String(stone.DiamondAmount || "0"), // Convert to string
              DiamondWeight: String(stone.DiamondWeight || "0"), // Convert to string
              
              DiamondRate: String(stone.DiamondRate || '0'),
              DiamondPieces: String(stone.DiamondPieces || '0'),
              DiamondSize: String(stone.DiamondSize || '')
          })),
            // stones:item.Stones.map(stone => ({
            //     ...stone,
            //     StoneAmount: String(stone.StoneAmount || "0"), // Convert to string
            //     StoneWeight: String(stone.StoneWeight || "0") // Convert to string
            // })),
        }));
    }
}

export default PayLoadService;
